<router-outlet />
<app-loader></app-loader>
<app-notification></app-notification>

